import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "address"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "address-map"
}, null, -1);
const _hoisted_3 = {
  class: "main-wrap address-wrap"
};
const _hoisted_4 = {
  class: "address-form"
};
const _hoisted_5 = {
  class: "address-input"
};
const _hoisted_6 = {
  class: "city"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "separator"
}, null, -1);
const _hoisted_8 = ["placeholder"];
const _hoisted_9 = {
  key: 0,
  class: "quick-tools"
};
const _hoisted_10 = {
  class: "tools-item"
};
const _hoisted_11 = {
  class: "tools-item"
};
const _hoisted_12 = {
  class: "address-list"
};
const _hoisted_13 = {
  key: 0,
  class: "loading"
};
const _hoisted_14 = {
  key: 1,
  class: "address-data"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "poi"
};
const _hoisted_17 = {
  class: "name"
};
const _hoisted_18 = {
  class: "address"
};
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_loading = _resolveComponent("van-loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_nav_bar, {
    border: false,
    title: $setup.title
  }, null, 8, ["title"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: _normalizeClass('dot ' + $setup.addressType + '-dot')
  }, null, 2), _createElementVNode("div", {
    class: "city-select",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goSelectCity && $options.goSelectCity(...args))
  }, [_createElementVNode("div", _hoisted_6, _toDisplayString($setup.cityName), 1), _createVNode(_component_van_icon, {
    name: require('@/assets/icon/arrow-down.svg'),
    color: "#333",
    size: "10px"
  }, null, 8, ["name"])]), _hoisted_7, _withDirectives(_createElementVNode("input", {
    class: "input",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.keyword = $event),
    type: "text",
    placeholder: $setup.addressType === 'start' ? '您在哪里上车？' : '您要去哪里？',
    onInput: _cache[2] || (_cache[2] = (...args) => $options.goPlaceSearch && $options.goPlaceSearch(...args))
  }, null, 40, _hoisted_8), [[_vModelText, $setup.keyword]])]), _createElementVNode("div", {
    class: "cancel-btn",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.goBack && $options.goBack(...args))
  }, "取消")]), $setup.pois && $setup.pois.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_van_icon, {
    name: "wap-home-o"
  }), _createTextVNode(" 家 ")]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_icon, {
    name: "hotel-o"
  }), _createTextVNode(" 公司 ")]), $setup.addressType === 'end' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "tools-item",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.goMapSelect && $options.goMapSelect(...args))
  }, [_createVNode(_component_van_icon, {
    name: "location-o"
  }), _createTextVNode(" 地图选点 ")])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [!$setup.pois || $setup.pois.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_van_loading, {
    size: "40px",
    color: "#ff9500",
    "text-color": "#777",
    vertical: ""
  }, {
    default: _withCtx(() => [_createTextVNode(" 正在查询... ")]),
    _: 1
  })])) : _createCommentVNode("", true), $setup.pois && $setup.pois.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pois, (poi, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "address-item",
      key: poi.id,
      onClick: $event => $options.selectAddress(index)
    }, [_createVNode(_component_van_icon, {
      name: "location-o"
    }), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(poi.name), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(poi.address), 1)]), _hoisted_19], 8, _hoisted_15);
  }), 128))])) : _createCommentVNode("", true)])])]);
}